import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { StylesProvider } from '@material-ui/core/styles';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { theme } from './themes';
import { DeviceApi } from './types';

declare global {
  interface Window {
    DeviceApi: DeviceApi;
  }
}

if (!window.DeviceApi) {
  window.DeviceApi = {
    hasLocationPermissions: () => true,
    requestLocationPermissions: () => {},
    getAppVersion: () => 'blah',
    getDeviceId: () => 'c4bc0061-e9f7-4d45-8ac6-f75264180090',
    getDisplayHeight: () => 1080,
    getDisplayWidth: () => 1920,
    getDeviceModel: () => 'someModel',
    getAndroidVersion: () => 10,
  };
}

ReactDOM.render(
  <StrictMode>
    <StylesProvider injectFirst>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </StylesProvider>
  </StrictMode>,
  document.getElementById('root'),
);

reportWebVitals();
